// call when an order is successfully handled by PayPal
// and after every change in the cart
const removePayPalGuard = () => {
  // these items are added to prevent "unpaid-orders" collection pollution
  if (localStorage.getItem('customerId')) localStorage.removeItem('customerId');
  if (localStorage.getItem('orderId')) localStorage.removeItem('orderId');
};

export { removePayPalGuard };
